import { Card, CardBody, Col, Row } from 'reactstrap'
import { H5, P } from '../../../AbstractElements'
import { latestArticlesVideosData } from '../../../Data/MiscellaneousData/FaqData'
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom'
import { LatestArticlesVideosTitle } from '../../../Utils/Constants'

export default function LatestArticlesVideos() {
    return (
        <Col lg={12}>
            <div className="header-faq"><H5 className="mb-0">{LatestArticlesVideosTitle}</H5></div>
            <Row className='latest-articles'>
                {latestArticlesVideosData.map((data) => (
                    <Col xl={4} className={data.colClass} key={data.id}>
                        <Row>
                            {data.child.map((item) => (
                                <div key={item.id} className={item.colClass}>
                                    <Card>
                                        <CardBody>
                                            <div className="d-flex">
                                                <FeatherIconCom className='m-r-30' iconName={item.icon} />
                                                <div className="flex-grow-1">
                                                    <H5 className="f-w-600">{item.title}</H5>
                                                    <P>{item.text}</P>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            ))}
                        </Row>
                    </Col>
                ))}
            </Row>
        </Col>
    )
}